import { h, Component } from 'preact';
import s from 'components/bolt/trailerOverlay/trailerOverlay.sss';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import 'store/bolt/trailerOverlay';
import { joinClasses, accessNested } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import VideoPlayer from 'components/bolt/videos/player';
import Store from 'store/store';
import HTML from 'components/core/html/html';

export default class TrailerOverlay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			closed: false,
			videoLoaded: false
		};

		// this.handleLoaded = this.handleLoaded.bind(this);
		this.toggleOverlayOpen = this.toggleOverlayOpen.bind(this);
		this.checkIfOverlayShouldShow = this.checkIfOverlayShouldShow.bind(this);

		this.disabled = parseQueryString()['no-overlay'];
	}

	componentDidMount() {
		this.checkIfOverlayShouldShow(null, true);
		Store.on('SET_ACTIVE_PAGE', this.checkIfOverlayShouldShow);
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeout);
		Store.off('SET_ACTIVE_PAGE', this.checkIfOverlayShouldShow);
		this.toggleOverlayOpen(false);
	}

	checkIfOverlayShouldShow(activePage) {
		if (this.props.manual) {
			return;
		}

		window.clearTimeout(this.timeout);

		const overlayTriggered = accessNested(this.props, 'store.trailerOverlay.overlayTriggered', false);
		const disableForGoogleBot = accessNested(this.props, 'data.disableForGoogleBot', false);
		const isGoogleBot = /Googlebot/i.test(navigator.userAgent);

		if (overlayTriggered || (disableForGoogleBot && isGoogleBot)) return;

		if (!activePage) activePage = accessNested(this.props, 'store.activePage');
		//let inclusions = accessNested(this.props, 'data.inclusions', '');
		let inclusions = accessNested(this.props, 'store.appData.options.videoOverlay.inclusions', '');

		if (inclusions) {
			inclusions = inclusions.split(',').map(page => page.trim());
		}

		if ((!inclusions.length || inclusions.includes(activePage)) && !this.disabled) {
			const delay = accessNested(this.props, 'store.appData.options.videoOverlay.delay', 0);

			this.timeout = window.setTimeout(() => {
				this.toggleOverlayOpen(true);
			}, delay * 1000);
		}
	}

	toggleOverlayOpen(open, e) {
		if (!open && e?.target?.id === 'youtubeCookieSettings') {
			return;
		}
		if (open) {
			this.overlayOpenAt = Date.now();
		} else {
			let now = Date.now();
			let openAt = this.overlayOpenAt || now;
			let duration = Math.floor((now - openAt) / 10) * 10;
			if (duration > 100) {
				duration = '100+';
			}
			Store.emit('POWSTER_GA_EVENT_TRACK', 'trailer-bounce', 'trailer', duration);
		}

		if (e?.target && !e.target.className?.includes('burgerMenu') && !e.target.className.includes(s.wrapper)) {
			return;
		}

		Store.emit('TOGGLE_TRAILER_OVERLAY', open);
	}

	// handleLoaded() {
	// 	this.setState({ videoLoaded: true });
	// }

	render() {
		// const { videoLoaded } = this.state;
		const { store } = this.props;
		let { overlayOpen, data } = store?.trailerOverlay || {};

		if (this.disabled) {
			overlayOpen = false;
		}

		const fontVariables = accessNested(store, 'appData.styling.fontVariables.galleryAnnotations', {});
		const { video, annotation } = data || {};
		let videoSubObject = video && Object.values(video).find(value => value && typeof value === 'object');
		// If the video object is not nested, consider it to be the video data itself, otherwise take the first subobject
		let activeVideo = videoSubObject || video;

		return (
			<div
				class={joinClasses(s.wrapper, overlayOpen && s.visible)}
				onClick={(e) => this.toggleOverlayOpen(false, e)}
			>
				<BurgerMenu
					type={overlayOpen ? 'close' : 'burger'}
					trailerOverlay
					extraClass={s.closeButton}
				/>
				{overlayOpen && (
					<VideoPlayer
						ref={ref => this.player = ref}
						extraClass={s.player}
						activeVideo={activeVideo}
						onEnded={() => this.toggleOverlayOpen(false)}
						// onLoaded={this.handleLoaded}
						hiddenPlaylist
						overrideStyles
						isTrailerOverlay
					/>
				)}
				{annotation && (
					<div style={fontVariables.galleryAnnotations} class={s.annotation}>
						<HTML markdown content={annotation} />
					</div>
				)}
			</div>
		);
	}
}